import React, { useContext } from "react";
import { ContextEngine } from "../engine/ContextEngine";
import "./TablePagination.css";

const TablePagination = ({ unitId, totalItems }) => {
  const { context, updateContext } = useContext(ContextEngine);

  // 1. Locate the specific unit in context
  const unitIndex = context.context_units?.findIndex((u) => u.id === unitId);
  const view = context.context_units?.[unitIndex]?.view || {};

  // 2. Extract state from the "view" object
  const page = view.page || 1;
  const pageSize = view.pageSize || 10;
  const totalPages = Math.ceil(totalItems / pageSize) || 1;

  // 3. Helper to update the view store
  const setView = (key, value) => {
    updateContext(`context_units.${unitIndex}.view.${key}`, value);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setView("page", newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setView("pageSize", newSize);
    setView("page", 1); // Reset to first page when changing size
  };

  const startIdx = (page - 1) * pageSize + 1;
  const endIdx = Math.min(page * pageSize, totalItems);

// Inside TablePagination.jsx

  return (
    <div className="table-pagination-container">
      {/* Page Size Selector */}
      <div className="pagination-section">
        <span>Rows per page:</span>
        <select 
          className="pagination-select" 
          value={pageSize} 
          onChange={handlePageSizeChange}
        >
          {[5, 10, 20, 50, 100].map(size => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>

      {/* Range Info */}
      <div className="pagination-info">
        {totalItems > 0 ? `${startIdx}-${endIdx} of ${totalItems}` : "0 of 0"}
      </div>

      {/* Navigation Triggers */}
      <div className="pagination-nav">
        {/* FIRST PAGE */}
        <button 
          className="pagination-btn"
          disabled={page <= 1} 
          onClick={() => handlePageChange(1)}
          title="First Page"
        >
          &lt;&lt;
        </button>

        {/* PREVIOUS PAGE */}
        <button 
          className="pagination-btn"
          disabled={page <= 1} 
          onClick={() => handlePageChange(page - 1)}
          title="Previous Page"
        >
          &lt;
        </button>

        <span className="pagination-current">{page} / {totalPages}</span>

        {/* NEXT PAGE */}
        <button 
          className="pagination-btn"
          disabled={page >= totalPages} 
          onClick={() => handlePageChange(page + 1)}
          title="Next Page"
        >
          &gt;
        </button>

        {/* LAST PAGE */}
        <button 
          className="pagination-btn"
          disabled={page >= totalPages} 
          onClick={() => handlePageChange(totalPages)}
          title="Last Page"
        >
          &gt;&gt;
        </button>
      </div>
    </div>
  );

};

export default TablePagination;
